import { HeroSection } from '../components/sections/HeroSection';
import { AboutSection } from '../components/sections/AboutSection';
import { BrandsSection } from '../components/sections/BrandsSection';
import { ProductCategories } from '../components/sections/ProductCategories';
import { CertificationsSection } from '../components/sections/CertificationsSection';
import { ClientsSection } from '../components/sections/ClientsSection';
import { WhyChooseUs } from '../components/sections/WhyChooseUs';
import { InquirySection } from '../components/sections/InquirySection';
import { FAQSection } from '../components/sections/FAQSection';
import { MapSection } from '../components/sections/MapSection';

export default function HomePage() {
  return (
    <main>
      <HeroSection />
      <AboutSection />
      <ProductCategories />
      <BrandsSection />
      <CertificationsSection />
      <ClientsSection />
      <WhyChooseUs />
      <MapSection />
      <InquirySection />
      <FAQSection />
    </main>
  );
}
